import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class PersonalityReferenceQueryService {

    public CREATE_REFERENCE: any;
    public GET_REFERENCES_DATA: any;

    constructor(public apollo: Apollo) {

        /* To create user */
        this.CREATE_REFERENCE = gql` 
          mutation CREATE_REFERENCE($input: CreatePersonalityReferenceInput!) {
            createPersonalityReference(input: $input) {
                personalityReference{
                  userId
                 }
            }
           }
        `;

        this.GET_REFERENCES_DATA =
            gql`
            query currentScheduleRequests($userId:UUID){                           
                allPersonalityReferences(condition:{userId:$userId}) {
                    nodes {
                        name
                        email
                        phone
                        userId
                    }
                }
            }
        `  ;
    }

    CREATE_PER_REFERENCE(values, userId): any {

        return this.apollo.mutate({
            mutation: this.CREATE_REFERENCE,
            variables: {
                "input": {
                    "personalityReference": {
                        "name": values.name,
                        "email": values.email,
                        "phone": values.phone,
                        "userId": userId
                    }
                }
            }
        })
    }


    FETCH_REFERENCES(userId): any {
        return this.apollo
            .watchQuery({
                query: this.GET_REFERENCES_DATA
                ,
                variables:
                {
                    "userId": userId
                },
                fetchPolicy: 'network-only'
            });
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/personalityReference.ts